type ImageDialogProps = {
  src: string
  name: string
  hasOverlay?: boolean
}

type OpenImageDialog = (props: ImageDialogProps) => Promise<unknown>

let openImageDialogImpl: OpenImageDialog | null = null

export const registerImageDialog = (open: OpenImageDialog): void => {
  openImageDialogImpl = open
}

export const openImageDialog = (props: ImageDialogProps): Promise<unknown> => {
  return openImageDialogImpl?.(props) ?? Promise.resolve()
}
